/** Radial dead zone preserves analogue speed and limits diagonal movement. */
export const TOUCH_LOOK_RADIANS_PER_PIXEL = 0.006;

export function touchLookDelta(
  dx: number,
  dy: number,
  sensitivity: number,
): { x: number; y: number } {
  const safeSensitivity = Number.isFinite(sensitivity)
    ? Math.max(0.5, Math.min(2, sensitivity))
    : 1;
  return {
    x: (Number.isFinite(dx) ? dx : 0) * TOUCH_LOOK_RADIANS_PER_PIXEL * safeSensitivity,
    y: (Number.isFinite(dy) ? dy : 0) * TOUCH_LOOK_RADIANS_PER_PIXEL * safeSensitivity,
  };
}

export function stickAxis(
  dx: number,
  dy: number,
  radius = 42,
  deadZone = 0.14,
): { x: number; z: number } {
  const distance = Math.hypot(dx, dy);
  if (!Number.isFinite(distance) || distance <= radius * deadZone) return { x: 0, z: 0 };
  const strength = Math.min(1, (distance / radius - deadZone) / (1 - deadZone));
  return { x: (dx / distance) * strength, z: (-dy / distance) * strength };
}
